import _ from 'underscore';
import Backbone from 'backbone';
import { SubscriptionModel } from './subscription-model';
import { SubscriptionView } from './subscription-view';

export var MembershipView = Backbone.View.extend({
  el: '.app__membership',

  initialize: function () {
    this.subscription = null;
    this.subscriptionView = null;
    this.listenTo(this.model, 'sync', this.render);
  },

  events: {
    'click [data-ms-click=subscription]': 'manageSubscription'
  },

  render: function () {
    var membershipName = this.model.get('membership').replace(/class$/, ''); // gold | silver | none
    var hasSubscription = this.model.get('hasSubscription');
    var pageName = this.$el.data('msPage'); // gold | silver

    // 정기권 구매하기, 사용중 표시
    if (membershipName === pageName && hasSubscription) {
      this.$('.ms-membership-using, .ms-membership-detail').show();
      this.$('.ms-membership-purchase').hide();
    } else {
      this.$('.ms-membership-using, .ms-membership-detail').hide();
      this.$('.ms-membership-purchase').show();
    }

    // 개월권 구매하기, 사용중 표시
    if (!hasSubscription && /gold|silver/.test(membershipName)) {
      this.$('.ms-monthly-' + membershipName)
        .find('.ms-membership-using')
        .show();
    } else {
      this.$('.ms-monthly .ms-membership-using').hide();
    }

    return this;
  },

  manageSubscription: function (e) {
    if (e && _.isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (this.subscriptionView) {
      this.subscription = null;
      this.subscriptionView.remove();
    }

    this.subscription = new SubscriptionModel();
    this.subscriptionView = new SubscriptionView({ model: this.subscription });
    var rendered = this.subscriptionView.el;
    $('.app__subscription').html(rendered);
  }
});
